import React from 'react';
import { FiSmartphone, FiArrowRight } from 'react-icons/fi';
import './Hero.css';
import story1 from '../images/story1.png';
import story2 from '../images/story2.png';
import story3 from '../images/story3.png';

const storyImages = [
  story1,
  story2,
  story3
];

const getRandomStoryImage = () => {
  const index = Math.floor(Math.random() * storyImages.length);
  return storyImages[index];
};

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content" data-aos="fade-right">
          <h1 className="hero-title">
            Engage Your Users with <span className="gradient-text glow-text">Interactive Stories</span>
          </h1>
          <p className="hero-description">
            StoryCape is a powerful SDK that allows you to integrate Instagram-like stories into your mobile app, increasing user engagement and retention.
          </p>
          <div className="hero-buttons">
          <a href="#how-it-works" className="btn btn-outline">
              How It Works
            </a>
            <a href="#contact" className="btn btn-primary glow">
              Contact Us <FiArrowRight className="btn-icon" />
            </a>
          </div>

          <div className="hero-stats">
            <div className="stat-item" data-aos="fade-up" data-aos-delay="100">
              <div className="stat-value">98%</div>
              <div className="stat-label">User Engagement</div>
            </div>
            <div className="stat-item" data-aos="fade-up" data-aos-delay="200">
              <div className="stat-value">2x</div>
              <div className="stat-label">Retention Rate</div>
            </div>
            <div className="stat-item" data-aos="fade-up" data-aos-delay="300">
              <div className="stat-value">5M+</div>
              <div className="stat-label">Daily Views</div>
            </div>
          </div>
        </div>

        <div className="hero-image" data-aos="fade-left">
          <div className="phone-mockup">
            <div className="phone-screen">
              <div className="story-top-bar">
                {Array.from({ length: 3 }).map((_, i) => (
                  <img
                    key={i}
                    src={storyImages[i]}
                    alt={`Story ${i + 1}`}
                    className="story-circle"
                  />
                ))}
              </div>
              <div className="story-content">
                <div className="story-header">
                  <div className="story-avatar" style={{ backgroundImage: `url(${getRandomStoryImage()})` }}></div>
                  <div className="story-info">
                    <div className="story-username">StoryCape</div>
                    <div className="story-time">Just now</div>
                  </div>
                </div>
                <div className="story-body">
                  <img src={getRandomStoryImage()} alt="Random app content" className="app-content-image" />
                </div>
                <div className="story-progress">
                  <div className="progress-bar">
                    <div className="progress-fill"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="phone-notch"></div>
            <div className="phone-button"></div>
          </div>

          <div className="decoration decoration-1"></div>
          <div className="decoration decoration-2"></div>

          {/*<div className="floating-icon floating-icon-1">
            <FiSmartphone />
          </div>
          <div className="floating-icon floating-icon-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="floating-icon floating-icon-3">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>*/}
          
          {/* Cheerful Emoji Floating Icons */}
          <div className="floating-icon floating-icon-5">
            <span role="img" aria-label="heart" style={{ fontSize: '24px' }}>😍</span>
          </div>
          <div className="floating-icon floating-icon-6">
            <span role="img" aria-label="rocket" style={{ fontSize: '24px' }}>❤️</span>
          </div>
          <div className="floating-icon floating-icon-7">
            <span role="img" aria-label="fire" style={{ fontSize: '24px' }}>🔥</span>
          </div>
          <div className="floating-icon floating-icon-8">
            <span role="img" aria-label="party" style={{ fontSize: '24px' }}>🎉</span>
          </div>
        </div>
      </div>

      <div className="hero-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
};

export default Hero;